export default __webpack_public_path__ + "static/media/241.db0d77ab.svg";